import { atom } from "recoil";

export const blackListLogWithdrawalsStore = atom({
	key: "blackListLogWithdrawalsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOrder: "",
		currentSearchType: "",
		currentDirection: "desc",
		search: "",
		selectedItems: [],
		sorting: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
		currentType: "",
		currentOption: {
			type: false,
			order: false,
			direction: false,
		},
	},
});
